var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelatorio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 110V102.5H97.5V98.75H90V91.25H97.5V87.5H85V80H100C101.417 80 102.604 80.4792 103.562 81.4375C104.521 82.3958 105 83.5833 105 85V90C105 91.4167 104.521 92.6042 103.562 93.5625C102.604 94.5208 101.417 95 100 95C101.417 95 102.604 95.4792 103.562 96.4375C104.521 97.3958 105 98.5833 105 100V105C105 106.417 104.521 107.604 103.562 108.562C102.604 109.521 101.417 110 100 110H85ZM85 75V61.25C85 59.8333 85.4792 58.6458 86.4375 57.6875C87.3958 56.7292 88.5833 56.25 90 56.25H97.5V52.5H85V45H100C101.417 45 102.604 45.4792 103.562 46.4375C104.521 47.3958 105 48.5833 105 50V58.75C105 60.1667 104.521 61.3542 103.562 62.3125C102.604 63.2708 101.417 63.75 100 63.75H92.5V67.5H105V75H85ZM92.5 40V17.5H85V10H100V40H92.5ZM15 93.875V86.375H73.875V93.875H15ZM15 63.5V56H73.875V63.5H15ZM15 33.125V25.625H73.875V33.125H15Z",
    fill: "url(#paint0_linear_79_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_4",
    x1: 60,
    y1: 10,
    x2: 60,
    y2: 110,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D81C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2594BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2594BD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelatorio);
export default __webpack_public_path__ + "static/media/relatorio.62793f6251b8944fabe70ceebb042714.svg";
export { ForwardRef as ReactComponent };